import React from 'react';
import './LoadingCircle.css';

const LoadingCircle = () => {
  return (
    <div className="loading-circle">
      <div className="circle"></div>
    </div>
  );
};

export default LoadingCircle;
